// src/components/layout/BottomNav.jsx
import React from 'react';
import { Home, Calendar, ShoppingBag, Bell, MessageSquare } from 'lucide-react';
import NavButton from '../common/NavButton';

const BottomNav = ({ activeScreen, setActiveScreen }) => (
  <div className="bg-white flex justify-around py-3 border-t border-gray-200 rounded-t-xl shadow-md">
    <NavButton 
      icon={<Home />} 
      isActive={activeScreen === 'home'}
      onClick={() => setActiveScreen('home')}
    />
    <NavButton 
      icon={<Calendar />} 
      isActive={activeScreen === 'agenda'}
      onClick={() => setActiveScreen('agenda')}
    />
    <NavButton 
      icon={<ShoppingBag />} 
      isActive={activeScreen === 'shop'}
      onClick={() => setActiveScreen('shop')}
    />
    <NavButton 
      icon={<Bell />} 
      isActive={activeScreen === 'notifications'}
      onClick={() => setActiveScreen('notifications')}
    />
    <NavButton 
      icon={<MessageSquare />} 
      isActive={activeScreen === 'chat'}
      onClick={() => setActiveScreen('chat')}
    />
  </div>
);

export default BottomNav;